"use strict";

exports.__esModule = true;
exports.onRouteUpdate = void 0;
var _arguments = arguments;

var onRouteUpdate = function onRouteUpdate() {
  console.log('$pageview', _arguments);

  if (window.posthog) {
    window.posthog.capture('$pageview');
  }
};

exports.onRouteUpdate = onRouteUpdate;